import Head from 'next/head';

interface GuideJsonLdProps {
  title?: string;
  summary?: string;
  firstPublishedAt?: string;
  publishedAt?: string;
}

type GuideObject = {
  '@context': string;
  '@type': 'Guide';
  about?: string;
  abstract?: string;
  dateCreated?: string;
  dateModified?: string;
};

export const GuideJsonLd = ({
  title,
  summary,
  firstPublishedAt,
  publishedAt,
}: GuideJsonLdProps) => {
  let guideObj: GuideObject = {
    '@context': 'https://schema.org',
    '@type': 'Guide',
  };

  guideObj = title ? { ...guideObj, about: title } : guideObj;

  guideObj = summary ? { ...guideObj, abstract: summary } : guideObj;

  guideObj = firstPublishedAt ? { ...guideObj, dateCreated: firstPublishedAt } : guideObj;

  guideObj = publishedAt ? { ...guideObj, dateModified: publishedAt } : guideObj;

  const guideJsonLd = JSON.stringify(guideObj);

  return (
    <>
      <Head>
        <script type="application/ld+json">{guideJsonLd}</script>
      </Head>
    </>
  );
};
